import { Private } from './containers'

export default Private